// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/MagicMenu/styles.css
// module id = 484
// module chunks = 0